import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AlertService {

  constructor(private http: HttpClient) { }
  urlEndPoint = environment.endPoint + '/api/alerts';

  getAlerts(user) {
    const params = new URLSearchParams();
    params.set('userId', user);
    return this.http.get<any>(this.urlEndPoint + '/get?' + params.toString());

  }

  getAlertGroups(alertId) {
    if (alertId != null) {
      const params = new URLSearchParams();
      return this.http.get<any>(this.urlEndPoint + `/${alertId}/groups`);
    }
    else {
      return JSON.parse(localStorage.getItem('alertGroups'));
    }
  }

  async getAllAlerts() {
    let alerts = JSON.parse(localStorage.getItem('alerts'));
    if (!alerts) {
      alerts = await this.http.get<any>(this.urlEndPoint + '/get?').toPromise();
      localStorage.setItem('alerts', JSON.stringify(alerts));
    }
    return alerts;
  }

  async getAllAlertGroups() {
    let alertGroups = JSON.parse(localStorage.getItem('alertGroups'));
    if (!alertGroups) {
      alertGroups = await this.http.get<any>(environment.endPoint + `/api/groups/alert/all`).toPromise();
      localStorage.setItem('alertGroups', JSON.stringify(alertGroups));
    }
    return alertGroups;
  }

  createAlert(alert) {
    
    alert.validFrom.setSeconds(0, 0)
    alert.validTo.setSeconds(0, 0)

    alert.validFrom = alert.validFrom.toLocaleString().replace(",", "");
    alert.validTo = alert.validTo.toLocaleString().replace(",", "");
    localStorage.removeItem('alerts');


    return this.http.post(this.urlEndPoint + `/create`, alert);
  }


  updateAlert(alert) {

    alert.validFrom = alert.validFrom.toLocaleString().replace(",", "");
    alert.validTo = alert.validTo.toLocaleString().replace(",", "");

    localStorage.removeItem('alerts');
    return this.http.post(this.urlEndPoint + `/update`, alert);
  }

  deleteAlert(alert) {

    delete alert.validFrom
    delete alert.validTo

    localStorage.removeItem('alerts');
    return this.http.post(this.urlEndPoint + `/delete`, alert);
  }

}
